import PhototherapyConfigPage from './PhototherapyConfigPage';
import { PHOTOTHERAPY_VARIANT } from '../../../apps/phototherapy/variants';

/**
 * Admin console for the "צהבת ביילוד" app (`PHOTOTHERAPY`).
 * Shares the whole UI with the צהבת ביילוד AAP 2022 console — only the AppConfig
 * identity and the default calculator differ, so each app keeps its own settings
 * per hospital.
 */
const PhototherapyConfig = () => <PhototherapyConfigPage variant={PHOTOTHERAPY_VARIANT} />;

export default PhototherapyConfig;
